import { Button } from "@mui/material";
import "../Common/css/styles.css";
import AuthLogin from "../Layouts/AuthLogin";
import Card from "../Components/Card";
import text from "../Assets/Text/Text.json";
import { useNavigate } from "react-router";
import { useState } from "react";
import PrimaryInputField from "src/Components/InputFields";
import logo from "../Assets/Images/va_black2.png"
import CustomAlert from "src/Components/Alerts";
import Spinner from "src/Components/Spinner";
import { adminLogin } from "src/Services/auth_api";
import { set } from "date-fns";

export default function AdminLogin() {
  const navigate = useNavigate();

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertDescription, setAlertDescription] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error" | "warning">("success");
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const showAlert = (description: string, type: "success" | "error" | "warning") => {
    setAlertDescription(description);
    setAlertType(type);
    setAlertOpen(true);
  };

  const handleLogin = async () => {
    setIsLoading(true);
    const body = {
      email: username,
      password: password
    }

    try{
      const res = await adminLogin(body)
      sessionStorage.setItem("username", res.data.name);
      sessionStorage.setItem("token", res.data.token);
      sessionStorage.setItem("adminId", res.data.id.toString());
      setTimeout(() => {
        setIsLoading(false);
        navigate("/admin/admin-dashboard");
      }, 3000);
    } catch (error: any) {
      setIsLoading(false);
      showAlert("Login failed. Please check your credentials.", "error");    
    }
  };

  return (
    <AuthLogin>
      <Card>
        <div className="login-main-outer">
          <CustomAlert
            open={alertOpen}
            onClose={() => setAlertOpen(false)}
            description={alertDescription}
            type={alertType}
            timeout={3000}
          />
          <Spinner isLoading={isLoading} />
          <div className="login-head">
            <span style={{fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"}}> {text.loginPage.loginHeading} </span>
          </div>

          <hr  style={{margin: "10px 0 20px 0"}}/>
          <div className="login-head-outer-main">
            <img className="content-logo" src={logo} alt="" />
          </div>
          <div className="space"></div>
          <div className="login-head-outer-main mt">
            <PrimaryInputField
              placeholder="Enter your email"
              helperText={text.loginPage.usernameLabel}
              value={username}
              type="text"
              disabled={false}
              width="400ch"
              size="small"
              onChange={(e: any) => setUsername(e.target.value)}
            />
          </div>
          <div className="login-head-outer-main">
            <PrimaryInputField
              placeholder="Enter your password"
              helperText={text.loginPage.passwordLabel}
              value={password}
              type="password"
              disabled={false}
              width="400ch"
              size="small"
              onChange={(e: any) => setPassword(e.target.value)}
            />
          </div>
          <div className="login-head-outer1">
          </div>
          <div className="login-head-outer2">
            <Button className="login-btn" variant="contained" onClick={() => handleLogin()}>
              {text.loginPage.loginButton}
            </Button>
          </div>
        </div>
      </Card>
    </AuthLogin>
  );
}